import styled from 'styled-components';

const ErrorMessage = styled.span<{ color?: string }>`
  font-size: 14px;
  color: ${(props) => props.color || props.theme.colors.functionalRed};
  font-weight: bold;
`;

export default ErrorMessage;
